import { useState, useEffect } from "react";
import classNames from "classnames";
import Instrument from "shared/games/instruments/Instrument";
import { isInstrumentCorrect } from "../state/selectors";
import { State } from "../state/reducer";
import FixedWhenScrolledMobileBar from "../atoms/FixedWhenScrolledMobileBar";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import prettyInstrument from "util/formatters/prettyInstrument";
import { MixPuzzleInstrument } from "shared/games/mixpuzzles/types";

interface Props {
  instrument: MixPuzzleInstrument;
  state: State;
}

export default function ReportCarFixedStatusBar({
  state,
  instrument: { instrument },
}: Props) {
  const correct = isInstrumentCorrect(state, instrument);

  return (
    <FixedWhenScrolledMobileBar>
      <div
        className={classNames(
          "flex items-center",
          correct ? "text-green-500" : "text-red-500"
        )}
      >
        {correct ? (
          <CheckCircleIcon className={"mr-1 h-4"} />
        ) : (
          <XCircleIcon className={"mr-1 h-4"} />
        )}
        <span className={""}>{prettyInstrument(instrument)}</span>
      </div>
    </FixedWhenScrolledMobileBar>
  );
}
